/**
 * redirect logic
 */

function genRandomNums(times) {
  var ans = '';
  for (let i = 0; i < times; i++) {
    ans += Math.floor(Math.random() * 10);
  }
  return ans;
}

(function redirect() {
  const uri = location.href;
  // const uri = '321312/multi_service_invite_123/index/31231'
  const INVITE_REGEX = /multi_service_invite_([0-9]+)\/index/ig;
  const matched = INVITE_REGEX.exec(uri)
  if (!Array.isArray(matched)) return

  const oldRandomKey = `_${matched[1]}`
  const cacheKey = `xl_invite${oldRandomKey}`
  if (localStorage.getItem(cacheKey)) return

  const newRandomKey = `_${genRandomNums(3)}`
  // set new key
  localStorage.setItem(`xl_invite${newRandomKey}`, '1')

  const [pre, post] = uri.split(oldRandomKey)
  const newUri = `${pre}${newRandomKey}${post}`
  console.log('newUri==>', newUri)
  location.href = newUri
}())